import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emailnotificationmanagement',
  templateUrl: './emailnotificationmanagement.component.html',
  styleUrls: ['./emailnotificationmanagement.component.css']
})
export class EmailnotificationmanagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
